import React from 'react';
import { observable, action, computed, toJS } from 'mobx';
import base from '../../tool/base';
import util from '../../util/index';
import { message, Modal, Select, Radio, Popconfirm } from 'antd';
const {
  catchApiError,
  getAccessToken,
  getMobile,
} = util;

export default class EcodeGenreStore {
  routing = null;
  constructor(routing) {
    this.routing = routing;
  }

  @observable genreList = [];
  @observable genreCount = 0;
  @observable functionList = [];
  @observable editID = '';
  @observable editValue = '';
  @observable editTitle = '';
  @observable titleName = "";
  @observable visible = false;
  @observable searchValue = "";
  @observable buttonLoading = false;
  @observable activeKey = '';
  @observable loadingRes = false;
  @observable pageSize = 10;
  @observable pageNum = 1;
  @observable genreTree = [];
  @observable genres = [];
  @observable folderId = '';
  @observable saveEditValue = '';


  @computed get genreTreeList() {
    const genreTree =  this.genreTree.map((item, index) => {
      let children = item.funcList ? item.funcList : [];
      children = children.map((t, i) => {
        return {
          title: `${item.g_name}/${t.g_name}`,
          value: `${item.g_id}_${t.g_id}`,
          key: t.g_id,
          // children: _childrens,
        }
      })
      return {
        title: item.g_name,
        value: item.g_id,
        key: item.g_id,
        children: children,
      }
    })
    return genreTree;
  }

  @computed get genreIDList() {
    let genreIDList = [];
    this.genres.map(item => {
      const i = toJS(item.value).split('_');
      if(!genreIDList.some(t => t == i[0])) genreIDList.push(i[0]);
    });
    return genreIDList;
  }

  @computed get funcIDList() {
    let funcIDList = [];
    this.genres.map(item => {
      const i = toJS(item.value).split('_');
      i[1] && funcIDList.push(i[1]);
    });
    return funcIDList;
  }

  @action
  initGenreTree = () => {
    this.searchValue = '';
    this.getProperty();
  }

  @action
  setGenreTreeList = (id) => {
    this.genreTreeList.map(item => {
      if(id === item.key) {
        item.children.length === 0 && this.getFunctionList({tredeId: id});
      }
    })
  }

  @action
  getGenres = (record) => {
    this.folderId = record.folderId;
    const genres = [];
    record.genreList.forEach(item => {
      const length = this.genreTreeList.length;
      let children = [];
      for(let i = 0; i < length; i++ ) {
        if(this.genreTreeList[i].value === item.g_id) {
          children = this.genreTreeList[i].children;
          break;
        }
      }
      if(children.length === 0) genres.push({value: item.g_id, label: item.g_name});
    });
    record.functionList.forEach(item => genres.push({value: `${item.g_tradeid}_${item.g_id}`, label: `${item.name}/${item.g_name}`}));
    this.genres = genres;
  }

  @action
  initEdit = () => {
    this.editID = '';
    this.editValue = '';
    this.editTitle = '';
    this.saveEditValue = '';
  }

  @action
  setState = (params = {}) => {
    Object.keys(params).map(key => {
      this[key] = params[key];
    })
  }

  @action
  getProperty = (params = {}) => {
    const param = {
      ...params,
      name: this.searchValue,
      access_token: getAccessToken(),
    };
    return new Promise((resolve) =>{
      base.callApi('/v5/ecode/getProperty', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){
          this.genreTree = data.data;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        resolve(data);
      });
    });
  }

  @action
  updateProperty = (params = {}) => {
    const param = {
      ...params,
      function: this.funcIDList,
      genre: this.genreIDList,
      appId: this.folderId,
      access_token: getAccessToken(),
    };
    return new Promise((resolve) =>{
      base.callApi('/v5/ecode/updateProperty', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){

        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        resolve(data);
      });
    });
  }

  @action
  genre_add = (params = {}) => {
    const param = {
      name: this.editValue.trim(),
      ...params,
      access_token: getAccessToken(),
      pageNum: params.pageNum || this.pageNum,
      pageSize: params.pageSize || this.pageSize,
    };
    this.buttonLoading = true;
    return new Promise((resolve) =>{
      base.callApi('/v5/ecode/defineProperty', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){
          this.getGenreList();
          message.success("添加行业成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        resolve(data);
        this.buttonLoading = false;
      });
    });
  }

  @action
  func_add = (params = {}) => {
    const param = {
      name: this.editValue.trim(),
      genre: this.editID,
      ...params,
      access_token: getAccessToken(),
    };
    this.buttonLoading = true;
    return new Promise((resolve) =>{
      base.callApi('/v5/ecode/defineProperty', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){
          this.getGenreList();
          message.success("添加职能成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        resolve(data);
        this.buttonLoading = false;
      });
    });
  }

  @action
  genre_edit = (params = {}) => {
    const param = {
      name: this.editValue.trim(),
      genreId: this.editID,
      ...params,
      access_token: getAccessToken(),
      pageNum: params.pageNum || this.pageNum,
      pageSize: params.pageSize || this.pageSize,
    };
    this.buttonLoading = true;
    return new Promise((resolve) =>{
      base.callApi('/v5/ecode/modifyProperty', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){
          this.getGenreList();
          message.success("修改行业成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        resolve(data);
        this.buttonLoading = false;
      });
    });
  }

  @action
  func_edit = (params = {}) => {
    const param = {
      name: this.editValue.trim(),
      functionId: this.editID,
      ...params,
      access_token: getAccessToken(),
    };
    this.buttonLoading = true;
    return new Promise((resolve) =>{
      base.callApi('/v5/ecode/modifyProperty', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){
          this.getGenreList();
          message.success("修改职能成功");
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        resolve(data);
        this.buttonLoading = false;
      });
    });
  }

  @action
  deleteGenre = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    base.callApi('/v5/ecode/deleteProperty', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
      if (data.status){
        this.getGenreList();
        message.success(data.msg || '删除成功');
      } else {
        message.config({
          top: 20,
        });
        message.error(data.msg);
      }
    });
  }

  @action
  getGenreList = (params = {}) => {
    const param = {
      pageNum: params.pageNum || this.pageNum,
      pageSize: params.pageSize || this.pageSize,
      name: this.searchValue,
      ...params,
      access_token: getAccessToken(),
    };
    this.loadingRes = true;
    return new Promise((resolve) =>{
      base.callApi('/v5/ecode/genreList', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        if (data.status){
          this.genreList = data.data;
          this.activeKey = '';
          this.genreCount = data.count;
        } else {
          message.config({
            top: 20,
          });
          message.error(data.msg);
        }
        this.loadingRes = false;
      });
    });
  }

  @action
  getFunctionList = (params = {}) => {
    const genreid = params.tredeId;
    const param = {
      ...params,
      access_token: getAccessToken(),
      // pageNum: params.pageNum || this.pageNum,
      // pageSize: params.pageSize || this.pageSize,
    };
    return new Promise((resolve) =>{
      base.callApi('/v5/ecode/functionList', 'POST', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) =>{
        try {
          if (data.status){
            this.functionList = data.data;
            // this.functionObj[genreid] = data.data;
          } else {
            message.config({
              top: 20,
            });
            message.error(data.msg);
          }
        } catch(e) {
          console.error(e);
        }
      });
    });
  }
  

  @action
  getColumns = () => {
    const columns = [
      {
        title: '职能名',
        dataIndex: 'g_name',
        key: 'g_name',
        // width: '15%'
      },
      {
        title: '职能ID',
        dataIndex: 'g_id',
        key: 'g_id',
        // width: '15%'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        width: '150px',
        render: (text, record, index) => {
          const genreId = record.g_tradeid;
          const funcId = record.g_id;
          return (
            <div>
              <span className='list-table-btn' onClick={() => this.setState({visible: true, editTitle: 'func_edit', editID: record.g_id, editValue: record.g_name, saveEditValue: record.g_name})}>修改</span>
              <Popconfirm title="是否确定删除？"
                          okText="确定"
                          cancelText="取消"
                          onConfirm={() => {
                            this.deleteGenre({generId: record.g_tradeid, functionId: record.g_id})
                          }}>
                <span className='list-table-btn'>删除</span>
              </Popconfirm>
            </div>
          )
        }
      },
    ]
    return columns;
  }
}



// WEBPACK FOOTER //
// ./src/stores/ecode/ecodeGenreStore.js